import React from 'react';
import SafeImage from '../../../../elements/SafeImage';

const DirectoryItemDetailsImage = props => {
    const {item} = props;

    if (!item.detailsImageUrl) return null;

    return <SafeImage style={{maxWidth: '100%'}} src={item.detailsImageUrl} />;
};

export default DirectoryItemDetailsImage;
